<div class="resource-data-review">
    <div class="sections-grid">
        <!-- Simple Fields -->
        @if (simpleFields.length > 0) {
        <mat-card class="section-card">
            <mat-card-header>
                <mat-card-title>Details</mat-card-title>
                @if (showEditButtons) {
                <button mat-icon-button (click)="editSimpleFields()" title="Edit all">
                    <mat-icon>edit</mat-icon>
                </button>
                }
            </mat-card-header>
            <mat-card-content>
                <div class="fields-list">
                    @for (sf of simpleFields; track sf.fieldApiName; let last = $last) {
                    <!-- {{ sf.generalProperties?.fieldApiName }} -->
                    @if(sf.field.generalProperties?.isGroup && sf.field.groupFields){

                    @if(sf.generalProperties?.fieldApiName !== 'medicationRequestMedicationGroupField'
                    && sf?.fieldApiName !== 'medicationRequestMedicationGroupField'
                    && sf?.fieldApiName !== 'ServiceRequestCategory'
                    && sf?.fieldApiName !== 'ServiceRequestCode'
                    ){

                    <div class="field-row group-field">
                        <span class="field-label subtitle-text-color-2">{{ sf.fieldLabel }}</span>
                        <div class="group-subfields">
                            @for(subKey of objectKeys(sf.field.groupFields); track subKey) {
                            @if(!isGroupFieldSubfieldHidden(sf.field, subKey)){
                            <div class="group-subfield">
                                <span class="subfield-label">{{ getGroupFieldSubfieldLabel(sf.field, subKey) }}</span>
                                <!-- {{sf.data | json }}
                                {{subKey}} -->
                                <span class="subfield-value">{{ formatReviewValue(sf.data?.[subKey]) }}</span>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    }
                    }@else{
                    @if(
                    sf?.field.generalProperties.fieldApiName !== 'ServiceRequestCategory'
                    && sf?.field.generalProperties.fieldApiName !== 'ServiceRequestCode'
                    ){
                    <div class="field-row">
                        <span class="field-label subtitle-text-color-2">{{ sf.fieldLabel }}</span>
                        <span class="field-value">{{ formatReviewValue(sf.data) | titlecase }}</span>
                    </div>
                    }
                    }
                    @if(!$last && sf.generalProperties?.fieldApiName !== 'medicationRequestMedicationGroupField'
                    && sf?.fieldApiName !== 'medicationRequestMedicationGroupField'
                    && sf?.field?.generalProperties?.fieldApiName !== 'ServiceRequestCategory'
                    && sf?.field?.generalProperties?.fieldApiName !== 'ServiceRequestCode'
                    ){
                    <!-- {{sf.fieldApiName}} -->
                    @if(sf?.fieldApiName !=="note"){
                    <mat-divider></mat-divider>
                    }
                    }
                    }
                </div>
            </mat-card-content>
        </mat-card>
        }
        <!--specialCase -->
        @for (sf of specialCaseFields; track sf.fieldApiName; let last = $last) {
        @if(!(sf.field.generalProperties?.isHidden && sf.field.generalProperties?.fieldApiName ===
        'ServiceRequestCategory')){
        <mat-card class="section-card">
            <mat-card-header>
                <mat-card-title>Details</mat-card-title>
                @if (showEditButtons) {
                <button mat-icon-button (click)="editSpecialCaseField(sf.fieldApiName)" title="Edit all">
                    <mat-icon>edit</mat-icon>
                </button>
                }
            </mat-card-header>
            <mat-card-content>
                <div class="fields-list">
                    <div class="field-row group-field">
                        <span class="field-label subtitle-text-color-2">{{ sf.fieldLabel }}</span>
                        <div class="group-subfields">
                            @if( sf.field.groupFields){
                            @for(subKey of objectKeys(sf.field.groupFields); track subKey) {
                            <!-- {{sf.data | json}} -->
                            <div class="group-subfield">
                                <!-- {{subKey}}
                                {{sf.data?.[subKey] | json}} -->
                                <span class="subfield-label">{{ getGroupFieldSubfieldLabel(sf.field, subKey) }}</span>
                                <span class="subfield-value">{{ formatReviewValue(sf.data?.[subKey]) }}</span>
                            </div>
                            }
                            } @else{
                            <div class="g-just-flex" style="justify-content: space-between;">
                                <span class="subfield-label">{{ sf.fieldLabel }}</span>
                                <!-- {{sf.data | json}} -->
                                <span class="subfield-value">{{ formatReviewValue(sf.data) }}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        }
        }


        <!-- Array Fields -->
        @for (apiName of getGroupedArrayKeys(); track apiName) {
        <mat-card class="section-card">
            <mat-card-header>
                <mat-card-title>{{ groupedArrayFields[apiName][0]?.fieldLabel }}</mat-card-title>
                @if (showEditButtons) {
                <button mat-stroked-button color="primary" class="ms-12 g-just-flex gap-2"
                    style="padding: 0px 12px !important; padding-left: 12px !important;"
                    (click)="addArrayItem(apiName)">
                    <mat-icon class="ms-4">add</mat-icon>
                    Add New</button>
                }
            </mat-card-header>
            <mat-card-content>
                @if (getArrayItemsForField(apiName).length === 0) {
                <div class="empty-state">No entries.</div>
                } @else {
                <div class="array-items-list">
                    @for (arrayItem of getArrayItemsForField(apiName); track arrayItem.index) {
                    <div class="array-item">
                        <div class="array-item-header">
                            <span class="item-number">#{{ arrayItem.index + 1 }}</span>
                            @if (showEditButtons) {
                            <div class="actions">
                                <button mat-icon-button (click)="editArrayItem(arrayItem)"
                                    title="Edit"><mat-icon>edit</mat-icon></button>
                                <button mat-icon-button (click)="deleteArrayItem(arrayItem)"
                                    title="Delete"><mat-icon>delete</mat-icon></button>
                            </div>
                            }
                        </div>
                        <div class="array-item-content">
                            @if (arrayItem.field.generalProperties.isGroup) {
                            <div class="fields-list">
                                @for (k of objectKeys(arrayItem.data); track k) {
                                @if (!isSubfieldHidden(arrayItem, k) && arrayItem.data[k] !== '' && arrayItem.data[k]
                                !== undefined && arrayItem.data[k] !== null) {
                                <div class="field-row">
                                    <span class="field-label">{{ getSubfieldLabel(arrayItem, k) }}</span>
                                    <span class="field-value">{{ formatReviewValue(arrayItem.data[k]) }}</span>
                                </div>
                                }
                                }
                            </div>
                            } @else {
                            <div class="field-row">
                                <span class="field-value">{{ formatReviewValue(arrayItem.data) }}</span>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
                }
            </mat-card-content>
        </mat-card>
        }
    </div>
</div>